var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnOzoneCleansed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#01A847",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 2,
    cx: 25,
    cy: 25,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.607 9.473A19.917 19.917 0 0025 5C13.954 5 5 13.954 5 25s8.954 20 20 20 20-8.954 20-20c0-5.195-1.98-9.927-5.227-13.482",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 26,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 29,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 26,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 30,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 28,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 32,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 35,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 32,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 34,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 38,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 41,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 38,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.937 21.162c1.338-.61 2.336-.915 2.994-.915.988 0 2.61 1 3.627 1s3.006-1 3.966-1c.96 0 2.885.915 3.933.915s3.136-.915 4.04-.915c.904 0 2.158.915 3.7.915 1.542 0 2.542-.915 3.583-.915 1.041 0 2.69.915 3.87.915 1.18 0 2.895-.915 3.967-.915 1.073 0 2.875.915 3.32.915",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}

export default SvgIcnOzoneCleansed;